module.exports = __webpack_public_path__ + "static/slide5-743x573-5cb284695d380fc2009a9663724c9a04.gif";